export default __webpack_public_path__ + "static/media/ic_nato.e1b03142.svg";